import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { ExpenseProjectionType } from '../api/budget-types';
import { useUpdateBudgetApi } from '../api/use-update-budget';
import { useCategoriesWithBuckets } from '../../category/categories-with-buckets';
// Define the schema for the projection settings form
const projectionSettingsSchema = z.object({
    settings: z.object({
        bucketProjections: z.record(z.string(), z.nativeEnum(ExpenseProjectionType)),
    }),
});
// Default projection type constant
const DEFAULT_PROJECTION_TYPE = ExpenseProjectionType.TWELVE_MONTH_AVERAGE;
export const useProjectionSettingsForm = (budget, onSuccess) => {
    const { mutate, isPending } = useUpdateBudgetApi({ onSuccess });
    const categoriesWithBuckets = useCategoriesWithBuckets();
    // Generate default values for the form
    const generateDefaultValues = () => {
        const defaultProjections = {};
        // Initialize with default projection type for all buckets
        categoriesWithBuckets.forEach((category) => {
            category.buckets.forEach((bucket) => {
                defaultProjections[bucket.id] = budget.settings?.bucketProjections?.[bucket.id] || DEFAULT_PROJECTION_TYPE;
            });
        });
        return {
            settings: {
                bucketProjections: defaultProjections,
            },
        };
    };
    const form = useForm({
        resolver: zodResolver(projectionSettingsSchema),
        defaultValues: generateDefaultValues(),
    });
    useEffect(() => {
        form.reset(generateDefaultValues());
    }, [budget, categoriesWithBuckets, form]);
    const handleSubmit = (values) => {
        // Merge the projection settings with the existing budget data
        const updatedBudget = {
            ...budget,
            settings: {
                ...budget.settings,
                bucketProjections: values.settings.bucketProjections,
            },
        };
        mutate(updatedBudget);
    };
    return {
        form,
        onSubmit: form.handleSubmit(handleSubmit),
        isSubmitting: isPending,
    };
};
